import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';
import { isMobileUA } from 'dpl/shared/utils';

import TransportationModal from './TransportationModal';
import { TRANSPORT_TYPES } from '../utils/constants';

const { AIR, GROUND } = TRANSPORT_TYPES;
const IS_MOBILE = isMobileUA();

export default function Transport({
  deliveryMethods,
  deliveryMethodsCount,
  breederFirstName,
  facilityLocation,
  puppyName
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const transportTypes = Object.keys(deliveryMethods);

  const hasTransportation =
    transportTypes.includes(AIR) || transportTypes.includes(GROUND);

  function handleOpenClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsModalOpen(true);
  }

  function handleCloseClick(e) {
    e?.stopPropagation?.();
    setIsModalOpen(false);
  }

  const transportDescription =
    deliveryMethodsCount === 1 ? 'pickup option' : 'pickup & drop-off options';

  const mobileTransportDescription = `transport option${
    deliveryMethodsCount === 1 ? '' : 's'
  }`;

  return (
    <div className="BreederSearchResultsTransport f2">
      <button
        type="button"
        className="fw-medium flex items-center gray pointer"
        tabIndex="0"
        onClick={handleOpenClick}
      >
        {hasTransportation && (
          <span className="flex mr1">
            {transportTypes.includes(AIR) && (
              <Icon
                className="mr1"
                name="flight-16"
                width="14px"
                height="14px"
              />
            )}
            {transportTypes.includes(GROUND) && (
              <Icon className="mr1" name="car-16" width="14px" height="14px" />
            )}
          </span>
        )}
        {deliveryMethodsCount ? (
          <p>
            {deliveryMethodsCount}{' '}
            {!IS_MOBILE ? transportDescription : mobileTransportDescription}
          </p>
        ) : (
          <p
            className={classnames('BreederSearchResultsTransport__text', {
              underline: IS_MOBILE
            })}
          >
            {!hasTransportation ? 'Local pickup only' : 'Transportation'}
          </p>
        )}
      </button>
      {isModalOpen && (
        <TransportationModal
          onCloseClick={handleCloseClick}
          deliveryMethods={deliveryMethods}
          breederFirstName={breederFirstName}
          facilityLocation={facilityLocation}
          puppyName={puppyName}
        />
      )}
    </div>
  );
}

Transport.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  deliveryMethods: PropTypes.object.isRequired,
  deliveryMethodsCount: PropTypes.number,
  breederFirstName: PropTypes.string,
  facilityLocation: PropTypes.string,
  puppyName: PropTypes.string
};

Transport.defaultProps = {
  deliveryMethodsCount: null,
  breederFirstName: null,
  facilityLocation: null,
  puppyName: null
};
